import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/ui/design-system/components';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

const DeleteAlertConfirmModal = NiceModal.create(({ alertName }) => {
    const modal = useModal();

    return (
        <AlertDialog
            open={modal.visible}
            onOpenChange={(open) => !open && modal.hide()}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Delete alert?</AlertDialogTitle>
                    <AlertDialogDescription className="font-sans">
                        Are you sure you want to delete "{alertName}"? This
                        action cannot be undone.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={() => modal.resolve(false)}>
                        Cancel
                    </AlertDialogCancel>
                    <AlertDialogAction
                        onClick={() => modal.resolve(true)}
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                    >
                        Delete
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
});

export default DeleteAlertConfirmModal;
